export class ConstructionSearchParam
{
    userId: any;
    companyId: any;
    contractId: any;
    contractAdministratorId: any;
    projectManagerId: any;
    customerId: any;
    jobClassIds: any[];
    jobTypeIds: any[];
    dispatchStatusIds: any[];
    contractNo: string;
    search: string;
    startDate: Date;
    endDate: Date;
    billingMonthYear: Date;
    isOpen: boolean;
    skip: number;
    take: number;
    acctClasses: any[];
    constAdmins: any;
    customers: any[];
    dispStatuses: any[];
    contractWipCommitId: any = null;

    /* PM Board Performance */
    JobPMIds: any[] = null;
    customerIds: any[] = null;
    jobStatusIds: any[] = null;
    contractStatusIds: any[] = null;
    contractPMIds: any[] = null;
    coordinatorIds: any[] = null;
    divisionsIds: any[] = null;
    percCompleteFilterValue: any[] = null;
    hasTMFilterValue: boolean = false;
    isTMFilterValue: boolean = false;
    mgrPMDirectReportsIds: any[] = null;
}
